/**
 * Supported locales configuration
 */

export const SUPPORTED_LOCALES = [
  'en',
  'ar',
  'bn',
  'es',
  'fa',
  'fr-CA',
  'hi',
  'ht',
  'hy',
  'it',
  'ja',
  'km',
  'ko',
  'pa',
  'pl',
  'ru',
  'th',
  'tl',
  'vi',
  'yi',
  'zh',
  'zh-Hans',
] as const;

export type SupportedLocale = typeof SUPPORTED_LOCALES[number];

export const DEFAULT_LOCALE: SupportedLocale = 'en';

/**
 * Check if a locale code is supported
 */
export function isValidLocale(locale: string): locale is SupportedLocale {
  return SUPPORTED_LOCALES.includes(locale as SupportedLocale);
}

/**
 * Get a valid locale, falling back to default if invalid
 */
export function getValidLocale(locale: string | undefined | null): SupportedLocale {
  if (!locale) {
    return DEFAULT_LOCALE;
  }
  return isValidLocale(locale) ? locale : DEFAULT_LOCALE;
}
